import { Component, OnInit } from '@angular/core';
import { AuthGuard } from '../alcance/guards/auth.guard';
import { Router } from '@angular/router';
import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { Usuario } from '../alcance/models/usuario';
import { AlertController, LoadingController, Platform, ToastController } from '@ionic/angular';
import { Notificacao } from '../models/notificacao';
import { FCM } from "@capacitor-community/fcm";
import { BaseService } from '../alcance/services/_base.service';
import { Estabelecimento } from '../models/estabelecimento';
import { BehaviorSubject, map, Subscription, tap } from 'rxjs';
import { Edificacao } from '../models/edificacao';
import { Cliente } from '../models/cliente';
import { FileOpener } from '@capacitor-community/file-opener/dist/esm';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { SplashScreen } from '@capacitor/splash-screen';
import { FilaDBService } from '../database/fila-db.service';
import { Haptics } from '@capacitor/haptics';
import { SincService } from '../services/sinc.service';
import { Preco } from '../models/preco';
import { environment } from 'src/environments/environment';
import { CompraService } from '../services/compra.service';
import { PrecoService } from '../services/preco.service';
import { AppdataService } from '../services/appdata.service';
import { StorageService } from '../alcance/services/storage.service';
import { App, AppInfo } from '@capacitor/app';
import { FormTmp } from '../alcance/interfaces/form-tmp';
import { prepararCanaisSinistro } from '../services/sinistro-notificacao';
import { Device } from '@capacitor/device';

@Component({
  standalone: false,
    selector: 'app-pages',
    templateUrl: './pages.page.html',
    styleUrls: ['./pages.page.scss'],
})
export class PagesPage implements OnInit {

    subscription!: Subscription;

    static alertController: AlertController;

    static session: BehaviorSubject<any> = new BehaviorSubject(false);

    appInfo?: AppInfo;

    constructor(public auth: AuthGuard,
        public router: Router,
        public storage: StorageService,
        public sinc: SincService,
		private platform: Platform,
        private alertController: AlertController,
		private precoService: PrecoService,
		private compraService: CompraService,
		private appdata: AppdataService,
        private filaDB: FilaDBService,
        private toastController: ToastController) {
            PagesPage.alertController = alertController;
        }

    get linkWeb(){
        // return environment.url.replace("https://api.", "https://").replace("/api/", "");
        if(environment.ambiente == 'local')
            return 'http://127.0.0.1:8000';
        else if(environment.ambiente == 'sandbox')
            return 'https://sandbox.e-brigada.com.br';
        else
            return 'https://e-brigada.com.br';
    }

    ngOnInit() {
        if(Capacitor.isNativePlatform()){
            PushNotifications.removeAllListeners().then(async () => {

                // On success, we should be able to receive notifications
                await PushNotifications.addListener('registration', (token: Token) => {
                    //console.log('Push registration success, token: ' + token.value);
                    this.auth.appkey = token.value;

                    FCM.subscribeTo({ topic: "e-brigada" }).then();
                });

                // Some issue with our setup and push will not work
                await PushNotifications.addListener('registrationError', (error: any) => {
                    console.log('Error on registration: ', error);
                });

                // Show us the notification payload if the app is open on our device
                await PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
                    this.showNotification(notification);
                });

                // Method called when tapping on a notification
                await PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
                    this.clkNotification(notification.notification.data);
                });

                await prepararCanaisSinistro();
                if(this.platform.is('android') && (await Device.getInfo()).androidSDKVersion! >= 26) {
                    await PushNotifications.createChannel({
							id: 'MEDIDOR_IOT',
							name: 'Medidor IoT',
							description: "Alertar de Medidores",
							importance: 5,
							lights: true,
							lightColor: '#DA2128',
							vibration: this.auth.usuario?.configuracao.app.vibrar,
							sound: this.auth.usuario?.configuracao.app.audio,
							visibility: 1
                    });
                }
                const conf = this.auth.usuario?.configuracao;
                if(conf && !conf.app.sinistro_push_v2){
                    conf.app.sinistro_push_v2 = true;
                    this.auth.saveConf(conf);
                }
                const permission = await PushNotifications.requestPermissions();
                if(permission.receive === 'granted'){
                    this.auth.enableAndroidBackgroundMode();
                    await PushNotifications.register();
                }else{
                    const aviso = await this.alertController.create({
                        header: 'Notificações desativadas',
                        message: 'Ative as notificações do E-brigada nos ajustes do celular para receber pedidos de ajuda com o app em segundo plano.',
                        buttons: ['OK']
                    });
                    await aviso.present();
                }

            }).catch(error => console.error('Falha ao preparar notificações nativas', error));

            App.getInfo().then(v => this.appInfo = v);

            SplashScreen.hide();
        }

		this.initStore();

        this.storage.get('session').then((s) => {
            PagesPage.session.next(s);

            if(!this.auth.usuario?.admin && !this.auth.usuario?.cliente?.modular && (!this.auth.usuario?.residente || this.auth.usuario.perfil) && Capacitor.isNativePlatform() && BaseService.online && !this.session){
                if(this.auth.usuario?.cliente?.conf.sinc_offline)
                    this.sinc.sincroniza();
            }
        });

        this.getTempForm()
    }

    get session(){
        return PagesPage.session.value;
    }

    get eds(){
        return this.auth.usuario?.isCliente && (this.auth.usuario?.cliente?.edificacoes as Edificacao[]).length > 1;
    }

    async showNotification(n: PushNotificationSchema){

        const toast = await this.toastController.create({
            mode: 'ios',
            animated: true,
            color: 'primary',
            // cssClass: 'toast-success',
            duration: 5000,
            header: n.title,
            message: n.body,
            position: 'top',
            icon: 'notifications',
            buttons: [{
                text: 'OK',
                role: 'cancel',
                handler: () => {
                    this.clkNotification(n.data);
                }
            }]
        });

        if(this.router.url.indexOf('mensagem') == -1 || (n.data.referencia && JSON.parse(n.data.referencia).edificacao_id != this.auth.usuario?.edificacao?.id))
            toast.present();

        switch(n.data.tipo){
            case 'SINISTRO':
                if(this.router.url.split('?')[0] != '/sinistro/' + n.data.ref)
                    this.router.navigate(['/sinistro', n.data.ref]);
                else
                    this.auth.event.next({sinistro: {id: n.data.ref}, disparar: true});
            break;
            case 'MEDIDOR_IOT':
                this.clkNotification(n.data as Notificacao);
            break;
        }
    }

    clkNotification(n: Notificacao){
        switch(n.tipo){
            case 'MENSAGEM':
                // if($scope.controle.usuario.cliente){
                //     $scope.controle.edificacao_id = item.referencia.edificacao_id;
                // }
                this.router.navigate(['/mensagem']);
            break;
            case 'PENDENCIA':
                // if($scope.controle.usuario.cliente){
                //     $scope.controle.edificacao_id = item.referencia.andar.edificacao_id;
                // }
                this.router.navigate(['/pendencia', n.ref]);
            break;
            case 'ATIVIDADE':
                // if($scope.controle.usuario.cliente){
                //     $scope.controle.edificacao_id = item.referencia.edificacao_id;
                // }
                this.router.navigate(['/atividade', n.ref]);
            break;
            case 'ATA':
                if(this.auth.usuario?.master)
                    this.router.navigate(['/ata', n.ref]);
                else
                    this.router.navigate(['/ata', n.ref, 'assinar']);
            break;
            case 'TREINAMENTO':
                if(n.ref)
                    this.router.navigate(['/treinamento', n.ref]);
                else
                    this.router.navigate(['/treinamento']);
            break;
            case 'EQUIPAMENTO':
                this.router.navigate(['/equipamento', n.ref]);
            break;
            case 'SINISTRO':
                if(this.router.url != '/sinistro/' + n.ref)
                    this.router.navigate(['sinistro', n.ref]);
            break;
            case 'MEDIDOR_IOT':
                if(this.router.url != '/medidor-iot-alerta/' + n.ref)
                    this.router.navigate(['/medidor-iot-alerta', n.ref]);
            break;
            case 'AGENDA':
                this.router.navigate(['/agenda', n.ref]);
            break;
            case 'ESTOQUE':
                this.router.navigate(['/estoque', n.ref, 'estoque-movimentacao']);
            break;
            case 'EPI_ENTREGA':
                this.router.navigate(['/epi-entrega', n.ref]);
            break;
            case 'SIMULACAO':
                this.router.navigate(['/simulacao', n.ref, 'executar']);
            break;
            case 'CERTIFICADO':
            break;
            case 'NOTIFICACAO':
                this.router.navigate(['/notificacao']);
            break;
        }
    }

    setEdificacao(edificacao: Edificacao, estabelecimento: Estabelecimento){
        ((this.auth.usuario as Usuario).cliente as Cliente).estabelecimento = estabelecimento;
        ((this.auth.usuario as Usuario).cliente as Cliente).edificacao = edificacao;
        this.auth.event.next({edificacao: edificacao});
    }

    async getTempForm(){
        const v: FormTmp = await this.storage.get('form-tmp');
        if(v){
            const a = await this.alertController.create({
                mode: 'ios',
                message: 'Encontrei um formulário parcial salvo. Deseja recuperar o formulário?',
                buttons: [
                    'Não',
                    {
                        text: 'Sim',
                        role: 'destructive'
                    }
                ]
            });

            await a.present()

            let p = await a.onDidDismiss();
            if(p.role == 'destructive'){
                this.router.navigate([v.route], {queryParams: {recoverTemp: true}});
            }else{
                await this.storage.del('form-tmp');
            }
        }
    }

    async takePic() {
        if(this.auth.online()){
            const image = await Camera.getPhoto({
                correctOrientation: true,
                quality: 70,
                width: 250,
                height: 250,
                //allowEditing: this.auth.usuario?.configuracao.app.edit_img,
                saveToGallery: false,
                promptLabelCancel: 'Cancelar',
                promptLabelHeader: 'Obter foto a partir da',
                promptLabelPhoto: 'Galeria',
                promptLabelPicture: 'Câmera',
                source: CameraSource.Prompt,
                resultType: CameraResultType.Uri
            });

            let contents: any;
            if(Capacitor.isNativePlatform()){
                contents = await Filesystem.readFile({
                    path: image.path as string,
                });
            }else{
                contents = await new Promise(async (resolve, _) => {
                    const response = await fetch(image.webPath as any);
                    const blob = await response.blob();
                    const fileReader = new FileReader();
                    fileReader.onloadend = function(){
                        resolve({data: fileReader.result});
                    }
                    fileReader.readAsDataURL(blob);
                });
            }

            (this.auth.usuario as Usuario).imagem = image.webPath;
            (this.auth.usuario as Usuario).avatar = contents.data;
            this.auth.update(this.auth.usuario).subscribe((r) => {
                (this.auth.usuario as Usuario).imagem = r.imagem;
                delete this.auth.usuario?.avatar;
            });
        }

        // // image.webPath will contain a path that can be set as an image src.
        // // You can access the original file using image.path, which can be
        // // passed to the Filesystem API to read the raw data of the image,
        // // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
        // var imageUrl = image.webPath;

        // // Can be set to the src of an image now
        // imageElement.src = imageUrl;
    }

    static async download(file: string | undefined, name: string | null = null){
        if(file){
            if(Capacitor.isNativePlatform()){
                if(BaseService.online === true){
                    const loading = await (new LoadingController()).create({
                        message: 'Fazendo o Download...',
                        // duration: 2000,
                        spinner: 'bubbles'
                    });
                    await loading.present();

                    const resp = await CapacitorHttp.get({url: file, responseType: 'blob'});

                    loading.message = 'Salvando no Dispositivo...';

                    const writ = await Filesystem.writeFile({
                        path: name || file.substring(file.lastIndexOf('/') + 1).split('?')[0],
                        data: resp.data,
                        directory: Directory.Data,
                        // encoding: Encoding.UTF8,
                    });

                    await FileOpener.open({
                        filePath: writ.uri
                    }).catch(() => {
                        PagesPage.alertController.create({mode: 'ios', header: 'Erro ao Abrir', message: 'Verifique se você possui o app necessário para abrir o arquivo.'}).then(a => a.present())
                    });

                    loading.dismiss();
                }else if(BaseService.online === false){
                    const result = await Filesystem.readdir({
                        directory: Directory.Data,
                        path: '/'
                    });

                    // console.log(result)

                    FileOpener.open({
                        filePath: result.files.find((f) => f.name == (name || file.substring(file.lastIndexOf('/') + 1).split('?')[0]))?.uri as string
                    }).catch(() => {
                        PagesPage.alertController.create({mode: 'ios', header: 'Erro ao Abrir', message: 'Verifique se você possui o app necessário para abrir o arquivo.'}).then(a => a.present())
                    });
                }else{
					setTimeout(() => {
						PagesPage.download(file, name);
					}, 1000);
				}
            }else{
                window.open(file, "_blank");
            }
        }
    }

    static async readFile(url: any): Promise<any>{
        return new Promise(async (resolve, _) => {
            const response = await fetch(url);
            const blob = await response.blob();
            const fileReader = new FileReader();
            fileReader.onloadend = function(){
                resolve({data: fileReader.result});
            }
            fileReader.readAsDataURL(blob);
        });
    }

    isSinc(){
        return this.filaDB.isSend || this.sinc.isSinc;
    }

    async shwSincMessage(){
        const toast = await this.toastController.create({
            mode: 'ios',
            color: 'tertiary',
            icon:  this.filaDB.isSend ? 'cloud-upload' : 'cloud-download',
            message: 'sincronização de dados em andamento.',
            duration: 2000
        });
        toast.present();
    }

    async resetSession(){
        let s = await this.storage.get('session');
        await this.storage.set('user', s.token);
        await this.storage.del('session');
        this.router.navigate(['/']);
        this.auth.getUsuario().subscribe(() => {
            PagesPage.session.next(false);
        });
    }

    async simularSincronizacao(){
        let a = await this.alertController.create({
            mode: 'ios',
            message: 'Deseja buscar todos os dados ou buscar apenas a partir da última data de sincronização',
            header: 'Selecione o Modo',
            buttons: [
                {
                    role: 'destructive',
                    text: 'TODOS',
                    handler: async () => {
                        await this.sinc.resetarSincronizacao();
                        this.sinc.sincroniza();
                    }
                },
                {
                    role: 'cancel',
                    text: 'Última Sincronização',
                    handler: () => {
                        this.sinc.sincroniza()
                    }
                }
            ]
        });

        await a.present();
    }

	initStore(){
		this.platform.ready().then(() => {
			if(BaseService.online && !this.appdata.initStore){
				this.precoService.get(null, {with: ['modulos'], order: 'valor ASC'}, {showLoader: 'false'}).pipe(map(r => {
					return r.data.filter((i: Preco) => i.valor > 0);
				}),
				tap((resp: Preco[]) => {
					resp.forEach((r: Preco) => {
						if(this.platform.is('capacitor')){
							if(this.platform.is('android') && r.metadata.google?.active){
								r.loja = 'GOOGLE';
								r.loja_id = r.metadata.google?.loja_id;
							}else if(!this.platform.is('android') && r.metadata.apple?.active){
								r.loja = 'APPLE';
								r.loja_id = r.metadata.apple?.loja_id;
							}
						}
					})
				})).subscribe((planos: Preco[]) => {
					this.appdata.planos = planos;

					if(this.platform.is('capacitor')){
						CdvPurchase.store.verbosity = CdvPurchase.LogLevel.DEBUG;
						CdvPurchase.store.validator = environment.url + "compra/checar";

						const {store, ProductType, Platform} = CdvPurchase;

						planos.forEach((plano: Preco) => {
							//Registrar produto
							if((plano.loja == 'APPLE' || plano.loja == 'GOOGLE') && plano.loja_id)
								store.register({
									id: plano.loja_id,
									// type: this.platform.is('android') ? ProductType.CONSUMABLE : ProductType.NON_RENEWING_SUBSCRIPTION,
									type: ProductType.PAID_SUBSCRIPTION,
									platform: this.platform.is('android') ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE,
									//group: 'Planos'
								});
						});

						//Compra Aprovada
						store.when().approved((transaction) => {
							transaction.verify();

							//SEM VALIDACAO
							// transaction.finish();
							// this.service.post({loja_id: transaction.products[0].id}, 'loja').subscribe(() => {
							//     // Swal.fire('Sucesso!', 'Sua compra foi processada e você já pode continuar a usar nossos serviços. Obrigado :)', 'success');
							//     this.router.navigate(['/']);
							// });
						});

						//Verificado com sucesso
						store.when().verified((receipt) => {
							this.compraService.post({
								preco_id: planos.find((plano: Preco) => plano.loja_id == receipt.sourceReceipt.lastTransaction().products[0].id)?.id || this.appdata.ordered?.id,
								cliente_id: this.auth.usuario?.cliente?.id,
								gateway: receipt.platform,
								receipt: receipt
							}, null, null, {showLoader: 'false'}).subscribe((r) => {
								receipt.finish();

								// EXECUTA TODA VEZ ENTAO MOSTRAR NO CLIQUE DO BOTAO
								// this.alertController.create({
								//     mode: 'ios',
								//     header: 'Sucesso!',
								//     message: 'Sua ordem de compra foi enviada, assim que o pagamento for identificado os recursos solicitados serão liberados'
								// }).then(a => a.present());

								// this.router.navigate(['/']);
							});
						});

						this.platform.is('android') ? store.initialize([Platform.GOOGLE_PLAY]) : store.initialize([Platform.APPLE_APPSTORE]);
						store.update();
						if(this.platform.is('capacitor') && !this.platform.is('android')){
							store.restorePurchases();
						}
					}

					this.appdata.initStore = true;
				})
			}else{
				setTimeout(() => {
					this.initStore();
				}, 60000);
			}
		});
    }
}
